// extracted by mini-css-extract-plugin
export default {"button":"Contact_button__469Rq","padding":"Contact_padding__Duwpy","contact":"Contact_contact__LfwoY"};